import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientService } from 'src/app/services/client.service';
import { StaffService } from 'src/app/services/staff/staff.service';
import { ErrorStateMatcher } from '@angular/material/core';
import { FormGroup, FormBuilder, FormControl, FormGroupDirective, FormArray, NgForm, Validators, } from '@angular/forms';
import { JobService } from 'src/app/services/jobs/job.service';
import { MpjobService } from 'src/app/services/jobs/mpjob.service';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material';
import { DeleteConfirmModalComponent } from '../../commons/delete-confirm-modal/delete-confirm-modal.component';


export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}


@Component({
  selector: 'app-edit-mp-job',
  templateUrl: './edit-mp-job.component.html',
  styleUrls: ['./edit-mp-job.component.scss']
})
export class EditMpJobComponent implements OnInit {
  tempTest = ['1', '2']
  placeholder = "Starting date"
  jobForm;
  clients: any;
  job;
  date
  matcher = new MyErrorStateMatcher();
  color: any;
  rgba: any;
  always: any;
  isDisabled;
  loading: boolean;
  jobId: any;
  typeOfView: any;
  trainerJobs: any;
  mps: any;

  selectedClient: any;
  selectedLocation: any;
  selectedMps: any;
  selectedLinkJob: any;

  selectedMpsForDb = [];
  user
  createdDate
  selectedOptions: any
  trackers = [
    "Medical",
    "Drugs",
    "Alcohol",
    "Uploaded To Sentinel"
  ]
  previousValue
  error: any

  @Input('singleJob') singleJob: any;
  @Output() editJobData: EventEmitter<any> = new EventEmitter();

  @Output() displayJob: EventEmitter<any> = new EventEmitter();
  displayArchive: any;
  constructor(public _mpJobService: MpjobService, public _jobService: JobService, public _snackBar: MatSnackBar, private activatedRoute: ActivatedRoute, public _clientService: ClientService,
    private cdr: ChangeDetectorRef,
    public _staffService: StaffService, private router: Router, public formBuilder: FormBuilder, public dialog: MatDialog) {
    this.activatedRoute.queryParams.subscribe(() => {
      if (this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras && this.router.getCurrentNavigation().extras.state) {
        this.job = this.router.getCurrentNavigation().extras.state.job
        this.typeOfView = this.router.getCurrentNavigation().extras.state.view
      }
      // if (this.router.getCurrentNavigation().extras.state.view) {
      //   this.typeOfView = this.router.getCurrentNavigation().extras.state.view
      // }
    })
    if (this.router.url.includes('edit-mpjob')) {
      console.log("current url details", this.router.url);

      this.activatedRoute.params.subscribe(params => {
        this.jobId = params.jobid ? params.jobid : params.id;
        if (this.jobId) {
          console.log('Params Here===>', params);
          console.log("what is the single job id", this.singleJob);

          this.getJob(this.jobId).then((res) => {
            this.job = res
            if (this.job && this.job.createdAt != null) {
              this.createdDate = this.job.createdAt
            }
            this.createForm();
            this.getClients();
            this.getMps();
            this.getTrainerJob();
            // this.jobForm.controls.tracker.setValue(this.selectedOptions);
          })
        }
      })
    }
  }


  createForm() {
    console.log("here it is call only job", this.job);
    console.log("here the full job with data", this.singleJob);

    this.date = this.job.startingDate
    this.color = this.job.color;
    this.jobForm = new FormGroup({
      title: new FormControl(this.job ? this.job.title : '', Validators.required),
      jobColor: new FormControl(this.job ? this.job.color : '', Validators.required),
      startingDate: new FormControl(this.job ? this.job.startingDate : ''),
      // client: new FormControl('', Validators.required),
      // location: new FormControl('', Validators.required),
      clients: this.formBuilder.array(this.getClientFormArray(this.job.clients)),
      meds: new FormControl(''),
      linkedJob: new FormControl(''),
      isArchive: new FormControl(''),
      tracker: new FormControl('', Validators.required),
    })

    this.jobForm.controls.tracker.setValue(this.selectedOptions);
    console.log("value of edit form =======", this.jobForm.value);

    if (this.user && this.user.isClient) {
      // console.log("call this or not");
      this.jobForm.controls['title'].disable();
      this.jobForm.controls['jobColor'].disable();
      this.jobForm.controls['clients'].disable();
      this.jobForm.controls['meds'].disable();
      // this.jobForm.controls['location'].disable();
      // this.jobForm.controls['course'].disable();
      this.jobForm.controls['startingDate'].disable();
      this.jobForm.controls['linkedJob'].disable();
      this.jobForm.controls['isArchive'].disable();
      this.jobForm.controls['tracker'].disable();
    }
  }


  getClientFormArray(clients): Array<any> {
    const clientsArr = [];
    _.forEach(clients, async (client) => {
      await clientsArr.push(new FormGroup({
        client: new FormControl(client.client._id),
        location: new FormControl(client.location._id),
      }))
    })
    return clientsArr;
  }

  getClientsLocation(clientId, location) {
    // console.log("what is the value of location", clientId, location);

    // console.log('getTing clocations', this.clients[_.findIndex(this.clients, {_id: clientId})])
    let newClient = this.clients[_.findIndex(this.clients, { _id: clientId })];
    // console.log("single client data", newClient);

    if (newClient != undefined) {
      let client = newClient.locations
      if (location) {
        const index1 = _.findIndex(client, function (o) { return o._id == location })
        client[index1]['added'] = true

      }
      return client
    } else {
      return newClient
    }
  }

  onChange(value) {
    // this.date = value;
    this.jobForm.patchValue({ startingDate: value })
    console.log("event call sucessfully", this.jobForm.value)
  }


  addClientInClients(event, client, i) {
    // let previousValue


    console.log("index of element", i);

    let clientId = client
    const index = _.findIndex(this.clients, function (o) { return o._id == clientId })

    if (index > -1) {

      const index1 = _.findIndex(this.clients[index].locations, function (o) { return o._id == event.value })
      console.log("whatt is the index 1 value", index1);
      this.clients[index].locations[index1]['added'] = true
      console.log("remaining client value", this.clients[index]);
      this.previousValue = event.value
    }




    let exits = this.jobForm.controls['clients'].value
    exits.forEach((singleValue) => {
      this.clients[index].locations.forEach((location) => {
        if (location._id == singleValue.location) {
          console.log("nothing to do");

        } else {
          if (location && location.added)
            delete location['added']
        }
      })


    })

  }


  clientChanged(event) {
    console.log("value when client is changed", event);
    console.log("total form value==========", this.jobForm);
  }

  get multipleClientsGroup() { return <FormArray>this.jobForm.get('clients') }


  AddMultipleClients() {
    const control = <FormArray>this.jobForm.controls.clients

    control.push(this.formBuilder.group({

      client: new FormControl('', Validators.required),
      location: new FormControl('', Validators.required),
    }))

  }


  deleteClient(data, i) {
    console.log("what is in client", data);
    console.log("index value============", i);
    const control = <FormArray>this.jobForm.controls.clients
    control.removeAt(i)
    let clientId = data.value.client
    let locationId = data.value.location
    const index = _.findIndex(this.clients, function (o) { return o._id == clientId })


    console.log("main index value", index);

    if (index > -1) {



      const index1 = _.findIndex(this.clients[index].locations, function (o) { return o._id == locationId })
      console.log("location index value===========", index1);
      // console.log("whatt is the index 1 value", index1);
      delete this.clients[index].locations[index1]['added']
      // console.log("remaining client value", this.clients[index].locations[index1]);
      // console.log("value of selected client", this.selectedClient);

    }
  }


  ngAfterViewChecked() {

    this.cdr.detectChanges();

  }

  ngOnInit() {

    this.user = JSON.parse(localStorage.getItem('userRoles'))
    if (this.singleJob) {
      console.log('this.singleJob', this.singleJob)
      this.job = this.singleJob
      this.displayJob.emit(this.job)
      this.selectedOptions = this.job.tracker
      if (this.job && this.job.createdAt != null) {
        this.createdDate = this.job.createdAt
      }
      this.getMps();
      this.getTrainerJob();
      this.jobId = this.singleJob._id
      this.createForm();
      this.getClients();
      // this.jobForm.controls.tracker.setValue(this.selectedOptions);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.singleJob && changes.singleJob.currentValue) {
      console.log("changes of when get job from client", changes.singleJob);

      this.singleJob = changes.singleJob.currentValue
      this.job = this.singleJob
      this.selectedOptions = this.job.tracker
      this.displayJob.emit(this.job)
      if (this.job && this.job.createdAt != null) {
        this.createdDate = this.job.createdAt
      }
      this.getMps();
      this.getTrainerJob();
      this.jobId = this.singleJob._id
      this.createForm();
      this.getClients();
      // this.jobForm.controls.tracker.setValue(this.selectedOptions);
      this.displayArchive = this.singleJob.isArchive
    } else {

      if (this.router.url.includes('edit-mpjob')) {
        this.activatedRoute.params.subscribe(params => {
          this.jobId = params.jobid ? params.jobid : params.id;
          if (this.jobId) {
            console.log('Params Here===>', params);
            console.log("what is the single job id", this.singleJob);

            this.getJob(this.jobId).then((res) => {
              this.job = res
              this.displayJob.emit(this.job)
              this.selectedOptions = this.job.tracker
              if (this.job && this.job.createdAt != null) {
                this.createdDate = this.job.createdAt
              }
              this.createForm();
              this.getClients();
              this.getMps();
              this.getTrainerJob();
              // this.jobForm.controls.tracker.setValue(this.selectedOptions);
            })
          }
        })
      }
    }
  }


  // Utility functions
  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data, width: '500px' });
    return dialogRef.afterClosed();
  }

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }



  clearForm() {
    console.log("Clear Form Called");
    this.jobForm.reset();
    this.ngOnInit();
  }

  async instructorChanged(data) {
    console.log('Data Here===>', data);
    this.selectedMps = data.value;
    // return this.selectedMps;

    // this.selectedMps = this.mps.filter(function (element) {
    //   return element !== undefined;
    // });
    this.jobForm.get('meds').setValue(this.selectedMps);
    return this.selectedMps
    // this.jobForm.controls.meds.setValue(this.selectedMps);
    // this.selectedMps.concat(data.value)
    // this.cdr.detectChanges()
  }

  addJob() {

    let unique = [];
    let newClientId;
    let removedClient;
    let newAddedMps = [];
    let alreadyExists = [];
    let deletedMp = [];
    let deletedMpForDb = [];
    let selectedMpsForDb = [];

    console.log('selectedMps=============>', this.selectedMps);
    if (this.jobForm.valid) {

      if (this.selectedMps && this.selectedMps.length) {
        this.selectedMps.forEach((item) => {
          if (item) {
            selectedMpsForDb.push(item._id)
          }
        })
        console.log('selectedMpsForDb=============>', selectedMpsForDb);
      }

      this.job.mps.forEach((item) => {
        deletedMpForDb.push(item._id)
      })

      deletedMp = _.difference(deletedMpForDb, selectedMpsForDb)
      if (deletedMp.length && deletedMp[0] == null) {
        deletedMp = [];
      }


      selectedMpsForDb.map(x => unique.filter(a => a == x).length > 0 ? null : unique.push(x));


      console.log('unique=============>', unique);

      // if (this.job.client._id != this.selectedClient._id) {
      //   newClientId = this.selectedClient._id;
      //   removedClient = this.job.client;
      // }

      this.job.mps.forEach((item) => {
        alreadyExists.push(item._id)
      })

      console.log('alreadyExists=============>', alreadyExists);

      newAddedMps = _.difference(unique, alreadyExists);



      let editedJob = {
        title: this.jobForm.controls['title'].value,
        jobColor: this.jobForm.controls['jobColor'].value,
        clients: this.jobForm.controls['clients'].value,
        // location: this.jobForm.controls['location'].value._id,
        startingDate: this.jobForm.controls['startingDate'].value,
        linkedJob: this.jobForm.controls['linkedJob'].value._id,
        meds: unique,
        removedClient: removedClient,
        newClient: newClientId,
        newMps: newAddedMps,
        removedMps: deletedMp,
        isArchive: this.jobForm.controls['isArchive'].value,
        tracker: this.jobForm.controls['tracker'].value
      }
      this.error = ''
      console.log('Add Job Calling:', editedJob);


      this._mpJobService.editJob(editedJob, this.job._id).subscribe(res => {
        console.log("RESPONSE", res)
        let msg = 'Job Details Edited Successfully'
        this.openSnackBar(msg, "OK")
        this.router.navigateByUrl('/mpjob/' + this.job._id)
        this.editJobData.emit(res)
        // this.router.navigate(['/jobs']);
      }, err => {
        console.log('Error while Adding job:', err);
        this.loading = false;
      })
    } else {
      this.error = "All fields are required"
      this.jobForm.markAllAsTouched()
    }
  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  archiveJob(event) {
    console.log("when check box is selected", event);

  }

  // clientChanged(data) {
  //   this.selectedClient = data.value;
  //   console.log(this.selectedClient);
  // }


  getClients() {
    this._clientService.getClients().subscribe((clients) => {
      this.clients = JSON.parse(JSON.stringify(clients));
      console.log("all clients details", this.clients);

      this.loading = false;


      if (this.job.clients && this.job.clients.length) {
        this.job.clients.forEach((singleClient) => {
          const element = this.clients.find((o) => {
            return o._id == singleClient.client._id
          })
          console.log("single element of client", element);
          if (element && element != undefined) {
            singleClient.client.locations = element.locations
          }
        })
      }


      // for(let i = 0; i < this.job.client.length; i++){
      //   let jobClient = this.job.client[i]
      //   const index = _.findIndex(this.clients, function (o) { return o._id == jobClient.client._id })

      //   if(index > -1){

      //     if(this.clients[index].locations.length){

      //       const index1 = _.findIndex(this.clients[index].locations, function (o) { return o._id == jobClient.location._id })

      //       if(index1 > -1) this.clients[index].locations.splice(index1, 1)

      //       if(!this.clients[index].locations.length) this.clients.splice(index, 1)

      //     }
      //     else{
      //       this.clients.splice(index, 1)
      //     }
      //   }
      // }

    });
  }


  getMps() {
    this._staffService.getMps().subscribe((res) => {
      this.mps = res;
      let tempData = this.mps
      let tempInsts = this.job.mps
      let selected = []
      let index = _.findIndex(tempInsts, function (o) {
        if (o && o._id) {

          let index2 = _.findIndex(tempData, function (i) {
            // console.log("i.name", i.name, "o.name", o.name)
            return i._id == o._id
          })
          selected.push(tempData[index2])
        }
      })
      console.log("selected mps------->", selected)
      this.selectedMps = selected
      this.jobForm.controls.meds.setValue(this.selectedMps);
    });
  }




  getTrainerJob() {
    console.log("Trainer Job List Here");
    this._jobService.getTrainerJob().subscribe((res => {
      console.log('Res here', res);
      this.trainerJobs = res;

      let temp = this.job;

      if (temp && temp.linkedJob && temp.linkedJob.title) {
        let index = _.findIndex(this.trainerJobs, function (o) {
          console.log("o.title", o.title, 'temp.course.title', temp.linkedJob.title)
          return o._id == temp.linkedJob._id
        })
        if (index > -1) {
          this.selectedLinkJob = this.trainerJobs[index];
        }
        this.jobForm.controls.linkedJob.setValue(this.selectedLinkJob);
        console.log("this.selectedLinkJob", this.selectedLinkJob)
      }

    }))
  }

  getJob(jobId) {
    return new Promise((resolve) => {
      this.loading = true;
      this._jobService.getMpJobById(jobId).subscribe((jobs) => {
        console.log('jobs response========>', jobs[0]);
        this.displayArchive = jobs[0].isArchive
        this.loading = false;
        resolve(jobs[0])
      });
    })
  }

  removeClientFormClients(index) {
    console.log(" check here index for remove from selection ", index)

    let clientCopy = this.job.client[index].client;
    let locationCopy = this.job.client[index].location;
    this.job.client.splice(index, 1)

    const foundClientIndex = _.findIndex(this.clients, function (o) { return o._id == clientCopy._id })

    if (foundClientIndex > -1) {
      // console.log(" Client Found ::: ", this.clients[foundClientIndex] ) 
      this.clients[foundClientIndex]['locations'].push(locationCopy)
    }
    else {
      console.log(" Client Not Found Add in clients array ")
      console.log(" Now add location in clients ")
      clientCopy['locations'] = []

      clientCopy['locations'].push(locationCopy)

      this.clients.push(clientCopy)

      this.selectedClient = null
      this.selectedLocation = null


    }



    console.log(" let clientCopy ", clientCopy)
    console.log(" let locationCopy ", locationCopy)

  }

  // addClientInClients(event) {

  //   console.group(" add client and location ")
  //   const selectedClientId = this.selectedClient._id
  //   const selectedLocationId = this.selectedLocation._id

  //   console.log(" this.selectedClient ", this.selectedClient)
  //   console.log(" this.selectedLocation ", event)

  //   console.log(" this.job.client 1", this.job.client[0])

  //   this.job.client.push({ client: this.selectedClient, location: this.selectedLocation })

  //   this.selectedClient = null

  //   const index = _.findIndex(this.clients, function (o) { return o._id == selectedClientId })

  //   if (index > -1) {

  //     const index1 = _.findIndex(this.clients[index].locations, function (o) { return o._id == selectedLocationId })

  //     if (index1 > -1) {
  //       this.clients[index].locations.splice(index1, 1)

  //       if (!this.clients[index].locations.length) this.clients.splice(index, 1)

  //     }

  //   }
  // }


  deleteJob() {
    console.log("single job value", this.job);
    console.log("only- id", this.jobId);
    this.openDialog(DeleteConfirmModalComponent, "Job").subscribe(confirm => {
      if (confirm == '') return
      else if (confirm == 'yes') {
        this._mpJobService.deleteJobs(this.job._id).subscribe(() => {
          this.loading = false;
          this.handleSnackBar({ msg: "Job Deleted successfully!", button: "Ok" });
          this.router.navigateByUrl('/jobs', { state: { view: this.typeOfView } });
        }, () => {
          this.handleSnackBar({ msg: "Something Went Wrong!", button: "Ok" });
          this.loading = false;
        });
      }
    })
  }


}
